import { onSnapshot, type Unsubscribe } from "firebase/firestore";
import { reportDataError, toAppError, type AppError } from "@/data/errors";
import { paths } from "@/data/firestore/paths";

export function subscribeSystemAdmin(uid: string, observer: {
  next: (isSystemAdmin: boolean) => void;
  error: (error: AppError) => void;
}): Unsubscribe {
  return onSnapshot(paths.systemAdmin(uid), { includeMetadataChanges: true }, (snapshot) => {
    if (snapshot.metadata?.fromCache || snapshot.metadata?.hasPendingWrites) return;
    const data = snapshot.data();
    observer.next(snapshot.exists() && data?.["role"] === "admin" && data?.["status"] === "active");
  }, (error) => {
    const appError = toAppError(error, "subscription-failed");
    reportDataError("subscribe system admin", appError);
    observer.error(appError);
  });
}
